












import { ErrorCode, ErrorSeverity, ThrowErrorFunction, isDownstreamErrorCode } from "~/modules/error";
import { HttpAdapter } from "~/backend/HttpAdapter/HttpAdapter";
import { AuthenticationMethod } from "~/backend/commons/authenticationMethods";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";
import { SimpleHttpAdapterImpl } from "~/backend/SimpleHttpAdapter/SimpleHttpAdapterImpl";
import { ContextManager } from "~/modules/contextManager/ContextManager";

import { OutboundAddressConfiguration } from "../model/outboundAddressConfiguration";
import { OutboundWorkflowAndQueueResponse } from "../model/outboundWorkflowAndQueueResponse";

import { PreviewOutboundService }  from "./previewOutbound.serviceInterface";

export class PreviewOutboundServiceImpl implements PreviewOutboundService {
    private simpleHttpAdapter: HttpAdapter;

    readonly #throwError: ThrowErrorFunction;

    constructor(ctx: ContextManager) {
        this.simpleHttpAdapter = new SimpleHttpAdapterImpl(ctx);
        this.#throwError = throwFlexSdkError(ctx);
        this.simpleHttpAdapter.setIsEdgeSupported(false);

    }

    





    public async getOutboundAddressConfiguration(accountSidPathParam: string, options?: object): Promise<OutboundAddressConfiguration> {
        const metadata = {
            module: "backend",
            severity: ErrorSeverity.Error,
            source: "previewOutbound.service.ts"
        };
        if (accountSidPathParam === null || accountSidPathParam === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter accountSidPathParam was null or undefined.");
        }

        let response;
        try {
            response = await this.simpleHttpAdapter.get<OutboundAddressConfiguration>(`https://preview[region].twilio.com/Flex/Accounts/${encodeURIComponent(String(accountSidPathParam))}/OutboundAddressConfiguration`, AuthenticationMethod.Basic, options);
        } catch (e) {
            if (isDownstreamErrorCode(e.code)) {
                const message = `PreviewOutboundService - ${e.message}`
                return this.#throwError(ErrorCode.DownstreamServiceError, metadata, message) as unknown as Promise<never>;;
            }

            return Promise.reject(e)
        }
        return response;
    }

    





    public async getOutboundWorkflowAndQueue(accountSidPathParam: string, options?: object): Promise<OutboundWorkflowAndQueueResponse> {
        const metadata = {
            module: "backend",
            severity: ErrorSeverity.Error,
            source: "previewOutbound.service.ts"
        };
        if (accountSidPathParam === null || accountSidPathParam === undefined) {
            this.#throwError(ErrorCode.InvalidParams, metadata, "Required parameter accountSidPathParam was null or undefined.");
        }

        let response;
        try {
            response = await this.simpleHttpAdapter.get<OutboundWorkflowAndQueueResponse>(`https://preview[region].twilio.com/Flex/Accounts/${encodeURIComponent(String(accountSidPathParam))}/OutboundWorkflowAndQueue`, AuthenticationMethod.Basic, options);
        } catch (e) {
            if (isDownstreamErrorCode(e.code)) {
                const message = `PreviewOutboundService - ${e.message}`
                return this.#throwError(ErrorCode.DownstreamServiceError, metadata, message) as unknown as Promise<never>;;
            }

            return Promise.reject(e)
        }
        return response;
    }
}

